module.exports = __webpack_public_path__ + "img/celular.00c79817.png";